export const environments: any = {
  "development": {
      "REACT_APP_NODE_ENV" : "development",
      "REACT_APP_NODE_PREMIUM_URL": "https://devapi.taxmann.dev/research-premium/api/v1/",
      "REACT_APP_NODE_TAX_PRACTICE_URL": "https://devapi.taxmann.dev/taxpractice/api/v1/taxPractice/",
      "REACT_APP_PRODUCT_ATTACHMENT_BASE_URL": "https://cdn.taxmann.com/taxmann-images/learning/",
      "REACT_APP_NODE_BOOKSTORE_BASE_URL": "https://devapi.taxmann.dev/bookstore/api/v1/",
      "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://devapi.taxmann.dev/dashboard/api/v1/",
      "REACT_APP_NODE_REDIS_URL": "https://devapi.taxmann.dev/research3/api/v1/research_module/", 
      "REACT_APP_REDIS_URL":"https://devapi.taxmann.dev/research3/api/v1/research_module/",
      "REACT_APP_SCCRET_KEY_MACID": "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
      "REACT_APP_NODE_LEARNING_URL": "https://devapi.taxmann.dev/learning/api/v1",
      "RESET_PASSWORD_SCREEN": "https://dev.taxmann.com/gp/auth/resetPassword",
      "REACT_APP_DOT_NET_BASE_URL":"https://lbackoffice.taxmann.com/researcnest/api/",
      "REACT_APP_ENDMILE_API_SERVER": "https://devapi.taxmann.dev/msc/api/v1/endmile/",
      "REACT_APP_MARKETING_API": "https://devapi.taxmann.dev/marketing/api/v1/marketing/api/v1/",
      "REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL": "https://devapi.taxmann.dev/sessionmgmt/api/v1/",
      },
    "uat": {
      "REACT_APP_NODE_ENV" : "uat",
      "REACT_APP_NODE_PREMIUM_URL": "https://premiumapi-uat.taxmann.com/premium/",//update
      "REACT_APP_NODE_TAX_PRACTICE_URL": "https://uatapi-new.taxmann.com/taxpractice/",//update
       "REACT_APP_PRODUCT_ATTACHMENT_BASE_URL": "https://cdn.taxmann.com/taxmann-images/learning/",
       "REACT_APP_NODE_BOOKSTORE_BASE_URL": "https://uatapi-new.taxmann.com/bookstore/",//update
      "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://uatapi-new.taxmann.com/bookstore-dashboard/",//update
       "REACT_APP_NODE_REDIS_URL": "https://researchapi-uat.taxmann.com/research_module/", //update
      "REACT_APP_REDIS_URL":"https://researchapi-uat.taxmann.com/research_module/",//update
       "REACT_APP_SCCRET_KEY_MACID": "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
       "REACT_APP_NODE_LEARNING_URL": "https://learningapi-uat.taxmann.com/learning",//update
      "RESET_PASSWORD_SCREEN": "https://uat.taxmann.com/gp/auth/resetPassword",//update
       "REACT_APP_DOT_NET_BASE_URL": "https://dotnetapi-uat.taxmann.com/researcnest/api/",//update
       "REACT_APP_ENDMILE_API_SERVER": "https://uatapi.taxmann.com/msc/api/v1/endmile/",
       "REACT_APP_MARKETING_API": "https://uatapi.taxmann.com/marketing/api/v1/marketing/api/v1/",
      "REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL": "https://session-uat.taxmann.com/api/",//update
      },
  "staging": {
      "REACT_APP_NODE_ENV" : "staging",
      "REACT_APP_NODE_PREMIUM_URL": "https://api-preprod.taxmann.com/premium",
       "REACT_APP_NODE_TAX_PRACTICE_URL": "https://preprodapi.taxmann.com/taxpractice/",
       "REACT_APP_PRODUCT_ATTACHMENT_BASE_URL": "https://cdn.taxmann.com/taxmann-images/learning/",
       "REACT_APP_NODE_BOOKSTORE_BASE_URL": "https://preprodapi.taxmann.com/bookstore/",
       "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://preprodapi.taxmann.com/bookstore-dashboard/",
       "REACT_APP_NODE_REDIS_URL": "https://researchapi-stag.taxmann.com/research_module/", 
       "REACT_APP_REDIS_URL":"https://researchapi-stag.taxmann.com/research_module/",
       "REACT_APP_SCCRET_KEY_MACID": "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
       "REACT_APP_NODE_LEARNING_URL":"https://learningapi-stag.taxmann.com/learning",
       "RESET_PASSWORD_SCREEN": "https://preprod.taxmann.com/gp/auth/resetPassword",
       "REACT_APP_DOT_NET_BASE_URL": "https://stagingapi.taxmann.com/api/",
       "REACT_APP_ENDMILE_API_SERVER": "https://uatapi.taxmann.com/msc/api/v1/endmile/",
       "REACT_APP_MARKETING_API": "https://uatapi.taxmann.com/marketing/api/v1/marketing/api/v1/",
       "REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL": "https://session-stag.taxmann.com/api/"

  },
  "production": {
      "REACT_APP_NODE_ENV" : "production",
      "REACT_APP_NODE_PREMIUM_URL": "https://api-live.taxmann.com/premium",
       "REACT_APP_NODE_TAX_PRACTICE_URL": "https://practiceprod.taxmann.com/taxPractice/",
       "REACT_APP_PRODUCT_ATTACHMENT_BASE_URL": "https://cdn.taxmann.com/taxmann-images/learning/",
       "REACT_APP_NODE_BOOKSTORE_BASE_URL": "https://prodapibookstore.taxmann.com/bookstore/",
       "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://prodapibookstore.taxmann.com/bookstore-dashboard/",
       "REACT_APP_NODE_REDIS_URL": "https://researchapi-live.taxmann.com/research_module/", 
       "REACT_APP_REDIS_URL":"https://researchapi-live.taxmann.com/research_module/",
       "REACT_APP_SCCRET_KEY_MACID": "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
       "REACT_APP_NODE_LEARNING_URL":"https://learningapi-live.taxmann.com/learning",
       "RESET_PASSWORD_SCREEN": "https://taxmann.com/gp/auth/resetPassword",
       "REACT_APP_DOT_NET_BASE_URL": "https://liveresearchapi.taxmann.com/api/",
       "REACT_APP_ENDMILE_API_SERVER": "https://liveapi.taxmann.com/msc/api/v1/endmile/",
       "REACT_APP_MARKETING_API": "https://liveapi.taxmann.com/marketing/api/v1/marketing/api/v1/",
       "REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL": "https://session-live.taxmann.com/api/",

  }
}

export const IndexName = {
    "learning": "Taxmann Learning",
    "research": "Taxmann Research",
    "practice" : "Taxmann Practice"
}

export const IndexLabelSuggestion= {
  [IndexName.learning]: "Learning",
  [IndexName.research]: "Research",
  [IndexName.practice] : "Practice"
}

export const urlPrefix = "/gp";

export const NO_IMAGE_SPEAKER = 'https://cdn.taxmann.com/taxmann-images/learning/no_speaker_img.png';

export const SEO_MAPPING = {
  LANDING_PAGE: {
    API_VALUE: "LANDING_PAGE",
    PARAMS: [],
    URL_CONTAINS: "/",
  },
  HOME_PAGE: {
    API_VALUE: "HOME_PAGE",
    PARAMS: [],
    URL_CONTAINS: "/home",
  }
};

export const RESEARCH_MAPPINGS: { [key: string]: string }= {
  'Case Laws':'caselaws',
  'Circulars & Notifications':'cirnot',
  'Articles':'articles',
  'News':'news'
}

export const FAQDATA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Taxmann.com | Premium?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Taxmann.com | Premium is an all-in-one platform integrating Research, Practice, and Learning. It offers unified search, advanced filters, instant previews, and comprehensive coverage for GST and Income Tax, enabling professionals to work smarter and faster."
      }
    },
    {
      "@type": "Question",
      "name": "What plans are available for Taxmann.com | Premium?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We currently offer: GST, Income Tax & Combo (covers both GST & Income Tax). Each plan provides access to Research, Practice, and Learning and their respective features. View detailed pricing on our Pricing Page."
      }
    },
    {
      "@type": "Question",
      "name": "Does the Combo plan include full coverage of GST & Income Tax?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. The Combo plan grants full access to both GST and Income Tax content within Research and Practice and all video content on the Learning platform."
      }
    },
    {
      "@type": "Question",
      "name": "Is there a Free Trial available?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We offer a 7-day Free Trial with Premium features (subject to limited downloads/prints). You can explore Research, Practice, Learning, and two free recorded workshops or masterclasses at no cost. Sign up for the Free Trial here."
      }
    },
    {
      "@type": "Question",
      "name": "How do I activate the 7-day Free Trial?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "1. Sign Up or Log In if you're an existing user 2. Fill out the Free Trial Activation form (Name, Email, Mobile No., PIN code) 3. Verify both email & mobile via OTPs 4. Trial starts immediately upon successful validation"
      }
    },
    {
      "@type": "Question",
      "name": "Can I use multiple devices during my trial?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Our single-device concurrency policy applies to trials. Logging in on a second device automatically logs out the first session."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need to provide credit card details for the trial?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Not necessarily. We may pilot a credit-card-based trial for some users. If you see the credit card option, no charges apply during the trial. You can choose to skip it if offered."
      }
    },
    {
      "@type": "Question",
      "name": "I already have a Research/Practice/Learning subscription. Can I try Premium?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Existing subscribers receive a one-time free trial. If you are eligible, a 'Try Premium Free' button appears on your dashboard. Follow the standard OTP steps to activate it."
      }
    },
    {
      "@type": "Question",
      "name": "After the trial, can I keep my old subscription instead of upgrading to Premium?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. If you do not subscribe to Premium post-trial, you will be reverted to your original access level. However, Premium's unified search and advanced AI features will no longer be available."
      }
    },
    {
      "@type": "Question",
      "name": "Can I upgrade from GST or IT to the Combo plan later?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. If you start with GST or Income Tax but later want both, you can upgrade by paying the difference. Currently, the online upgrade is not available. Contact our Support Team to arrange the offline upgrade."
      }
    },
    {
      "@type": "Question",
      "name": "What are the current prices for Premium plans?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "- Premium GST: ₹35,000/year\n- Premium Income Tax: ₹37,000/year\n- Premium Combo: ₹51,000/year\nThese are annual subscriptions. Introductory rates are subject to revision. Check for any ongoing promotions or discounts."
      }
    },
    {
      "@type": "Question",
      "name": "Are monthly subscriptions available?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Not at present. We focus on annual billing to offer the best value. Contact our Sales Team if you have specific needs."
      }
    },
    {
      "@type": "Question",
      "name": "How does the Combo plan compare cost-wise to separate GST or IT plans?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The Combo plan is significantly discounted relative to purchasing GST and IT separately. For comprehensive coverage, the Combo is typically the most cost-efficient option."
      }
    },
    {
      "@type": "Question",
      "name": "Is there a discount for existing Research, Practice, or Learning subscribers?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Existing subscribers may qualify for a discount when upgrading to Premium. Please contact our Sales/Support Team to learn more."
      }
    },
    {
      "@type": "Question",
      "name": "How many users can access Premium on a single subscription?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "One subscription is for one user (single-user login). For multi-user or corporate needs, please contact Sales for custom pricing."
      }
    },
    {
      "@type": "Question",
      "name": "Where can I find detailed features for Research, Practice, and Learning?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "For a comprehensive breakdown, visit the individual pages:\n- Research\n- Practice\n- Learning\nTaxmann.com | Premium unifies all these features under one subscription."
      }
    },
    {
      "@type": "Question",
      "name": "Which AI tools are included or planned for Premium?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We are introducing the following AI tools:\n1. Generative Bot – Summaries beneath the search bar\n2. Summarizer – Condenses lengthy documents\n3. Comparison – Views two documents side by side\n4. Upload & Search – Upload your file to locate relevant references\n5. Submission Validation – Checks compliance within your draft\n6. Winning Probability – Estimates litigation success rates\n7. Citation Analysis – Validates references and integrates relevant materials"
      }
    },
    {
      "@type": "Question",
      "name": "Will I receive newsletters after my trial expires?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. You will receive three weekly newsletters highlighting key Premium features, trial insights, and occasional exclusive offers."
      }
    },
    {
      "@type": "Question",
      "name": "Can I unsubscribe from these newsletters?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Each email contains an unsubscribe link. However, we recommend staying subscribed for at least three weeks to access user-specific tips and potential discounts."
      }
    },
    {
      "@type": "Question",
      "name": "What is your refund policy for Premium subscriptions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "- Within the first 7 days of a paid subscription: A partial or full refund may be granted (at our discretion) if minimal content has been consumed.\n- After 7 days: Refunds are generally not provided, and access continues until the end of the subscription term.\nKindly review our Terms & Conditions or contact Support for details."
      }
    },
    {
      "@type": "Question",
      "name": "If I cancel during the free trial, will I be charged?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. There is no charge during the free trial. If you choose not to subscribe after the trial, you will owe nothing, and Premium features will simply end."
      }
    }
  ]
}